// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-text[data-v-36aaca90]{all:unset;display:flex;padding:12px 16px;align-items:center;justify-self:stretch;gap:12px;border-radius:8px;background-color:var(--background-bg-medium,#111924);line-height:16px;letter-spacing:.24px}", ""]);
// Exports
module.exports = exports;
